import * as React from "react"
import Svg, { Path } from "react-native-svg"

function KYCFastSecure(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <Path
                d="M9.146 10.979L7.5 9.333a.623.623 0 00-.458-.187.623.623 0 00-.459.187.62.62 0 00-.187.455c0 .178.062.332.187.462l2.063 2.083a.6.6 0 00.437.188.6.6 0 00.438-.188l3.875-3.875a.615.615 0 00.187-.448.56.56 0 00-.177-.427.592.592 0 00-.448-.156.628.628 0 00-.437.177l-3.375 3.375zm.854 7.27a.96.96 0 01-.396-.082c-1.93-.653-3.458-1.823-4.583-3.51a9.806 9.806 0 01-1.688-5.555V5.02c0-.268.076-.508.227-.722.15-.214.346-.37.586-.466l5.416-2.02A1.28 1.28 0 0110 1.728c.139 0 .285.028.438.083l5.416 2.021c.24.096.435.252.586.466.151.213.227.454.227.722V9.1a9.806 9.806 0 01-1.688 5.555c-1.125 1.688-2.653 2.858-4.583 3.51a.96.96 0 01-.396.083zm0-1.228c1.597-.528 2.9-1.525 3.906-2.99 1.007-1.465 1.51-3.108 1.51-4.927V5.021L10 2.979 4.583 5.021v4.083c0 1.82.504 3.462 1.51 4.927 1.008 1.465 2.31 2.462 3.907 2.99z"
                fill="#00813B"
            />
        </Svg>
    )
}

export default KYCFastSecure
